import moment from 'moment';
import {
  // 时间筛选器
  RANGE_TIME as FILTER_RANGE_TIME,
  // 单数据源筛选器
  SINGLE_SOURCE_SELECT as FILTER_SINGLE_SOURCE_SELECT,
  SINGLE_SOURCE_SELECT_EXTEND_TYPE,
  TIPICON,
} from '@/pages/intelligence/components/Filter/FilterBase/_config';
import { DOUYIN_SOURCES } from '@/pages/intelligence/_config/storeRank/config';

const isValidDate = (date: moment.Moment) =>
  // 选择范围在今天之前
  date.isSameOrBefore(moment(), 'day');

// 抖音小游戏筛选器默认配置
export const DOUYIN_FILTER_DEFAULT_LIST_MAP = {
  FILTER_RANGE_TIME: {
    savePopupVisble: 1,
    key: FILTER_RANGE_TIME,
    type: FILTER_RANGE_TIME,
    visible: 1,
    disabled: false,
    disabledDate: isValidDate,
    calendarType: 'date',
    autoRange: {
      timeType: 'date',
      length: 0,
    },
    showSelectType: false,
    showShortcut: false,
  },
  FILTER_SINGLE_SOURCE_SELECT: {
    savePopupVisble: 1,
    key: FILTER_SINGLE_SOURCE_SELECT,
    type: FILTER_SINGLE_SOURCE_SELECT,
    extendFilterType: SINGLE_SOURCE_SELECT_EXTEND_TYPE.common,
    visible: 1,
    disabled: false,
    entityType: 'mobile',
    sources: DOUYIN_SOURCES,
    isNotSaveByDefault: true, // 保存弹窗默认不勾选
  },
  TIPICON: {
    savePopupVisble: 0,
    key: TIPICON,
    visibleinlist: 1,
    content: 'dbi_douyin_filter_info',
  },
};

// 抖音小游戏筛选器默认值
export const DOUYIN_FILTER_DEFAULT_VALUE = {
  [FILTER_RANGE_TIME]: {
    type: 'date',
    value: [moment(), moment()],
  },
  [FILTER_SINGLE_SOURCE_SELECT]: {
    value: DOUYIN_SOURCES[0],
  },
};

// 抖音小游戏筛选器默认配置
export const DOUYIN_FILTER_DEFAULT_INPUT_LIST = [
  DOUYIN_FILTER_DEFAULT_LIST_MAP.FILTER_RANGE_TIME,

  DOUYIN_FILTER_DEFAULT_LIST_MAP.TIPICON,
];

// 抖音游戏榜单名组
export const DOUYIN_GAME_RANKING_KEY_LIST = ['douyin_popularity', 'douyin_bestseller', 'douyin_fresh_game'];
export const DOUYIN_GAME_RANKING_KEY_MINIGAME_LIST = ['minigame__douyin_popularity', 'minigame__douyin_bestseller', 'minigame__douyin_fresh_game'];

// 下钻页对应名称
export const DOUYIN_GAME_RANKING_MORE_TITLE_MAP: Record<string, string> = {
  douyin_popularity: 'dbi_top_rank_douyin_popularity',
  douyin_bestseller: 'dbi_top_rank_douyin_bestseller',
  douyin_fresh_game: 'dbi_top_rank_douyin_fresh_game',
};

export const DOUYIN_GAME_RANKING_MORE_TABLE_TITLE_MAP: Record<string, string[]> = {
  douyin_popularity: ['douyin_popularity|game_rank', 'douyin_popularity|avg_rank_30d'],
  douyin_bestseller: ['douyin_bestseller|game_rank', 'douyin_bestseller|avg_rank_30d'],
  douyin_fresh_game: ['douyin_fresh_game|game_rank', 'douyin_fresh_game|avg_rank_30d'],
};

export const DOUYIN_GAME_SOURCE = 'douyin';
